import CircularProgress from '@mui/material/CircularProgress';
import mixpanel from 'mixpanel-browser';
import styled, { css } from "styled-components";


const LoadingWrapper = styled.div`
  width: 100%;
  height: 100px;
  text-align: center
`;
const SubTitle = styled.div`
font-family: Gongim-Medium;
font-size: 32px;
@media (max-width: 1099px) {
  font-size: 18px;
}
`;

export default function Info() {

    mixpanel.track("info 페이지에 접속");
    // 접수페이지를 바로 이동될수있게 리플레이스 작업을 진행한다.
    window.location.replace('/')

    return (
        <>
            <LoadingWrapper>
                <CircularProgress />
                <SubTitle>접수 페이지로 이동중..</SubTitle>
            </LoadingWrapper>
        </>
    )
}